module.exports = __webpack_public_path__ + "assets/blob-4-selected.6982b0fa.svg";